import { useCustomCSSEditor } from '../../../../../hooks/useCustomCSSEditor';
import { SettingsAccordion } from '../../SettingsAccordion';
import { IconBorder } from '@bynder/icons';
import InspectorPanelColorPicker from '../../ColorPicker';
import { Thumbnail, Form } from '@bynder/design-system';
import {
  useActiveThemeset,
  useGetThemesetColors,
} from '../../../../../queries/themesets';
import { CSS_PROPERTIES } from '../../constants';
import { useTranslate } from '@bynder/localization';
import { defaultTransparent } from '../../../../widgets/RichText/Config';
import InspectorBorderRadius from '../../InspectorBorderRadius';
import { useWidgetStyleProperty } from '../../helpers';

const CardBorderRadius = ({
  style,
  handleStyleChange,
}: {
  style: string;
  handleStyleChange: (value: string) => void;
}) => {
  const { translate } = useTranslate();
  const { findColorFromStyle, clearStyle, addColorToStyle } =
    useCustomCSSEditor(style);
  const { data: themeset } = useActiveThemeset();
  const customColors = [...useGetThemesetColors(), defaultTransparent];

  const handleClear = (property, selector?) => {
    const newStyle = clearStyle(property, selector);
    handleStyleChange(newStyle);
  };

  const handleClick = (colorId, property, selector?) => {
    const newStyle = addColorToStyle(colorId, property, selector);
    handleStyleChange(newStyle);
  };

  const defaultCardBorderColor =
    themeset?.widgets.card.borderColor?.hexCode || defaultTransparent.hexCode;

  const { value: borderRadius, origin: borderRadiusOrigin } =
    useWidgetStyleProperty(
      style,
      'widgets.card.borderRadius',
      CSS_PROPERTIES.BORDER_RADIUS,
    );
  return (
    <SettingsAccordion
      noDivider
      thumbnail={<Thumbnail icon={<IconBorder />} />}
      title="Border"
    >
      <Form.Group data-testid="cardBorderRadius">
        <InspectorBorderRadius
          style={style}
          handleStyleChange={handleStyleChange}
          borderRadius={borderRadius}
          origin={borderRadiusOrigin}
        />
      </Form.Group>
      <Form.Group>
        <InspectorPanelColorPicker
          testId="cardBorderColor"
          handleClick={colorId => {
            handleClick(colorId, CSS_PROPERTIES.BORDER_COLOR);
          }}
          activeColor={findColorFromStyle(CSS_PROPERTIES.BORDER_COLOR)}
          handleClear={() => {
            handleClear(CSS_PROPERTIES.BORDER_COLOR);
          }}
          colors={customColors}
          defaultColorHex={defaultCardBorderColor}
          label={translate('WIDGET_INSPECTOR.CARD_HOVER')}
        />
      </Form.Group>
    </SettingsAccordion>
  );
};
export default CardBorderRadius;
